<ng-container [formGroup]="formGroup">

    <mat-form-field class="width" [appearance]="appearance">

        <mat-label>{{currentSelection? currentSelection?.issuetitle: 'Vorgang suchen'}}</mat-label>
        <input type="text" placeholder='Suchbegriff eingeben' matInput formControlName="filter" [matAutocomplete]="auto" (keyup.enter)="search($event.target.value)" /> 
        <mat-icon matSuffix (click)="search($event.target.value)">search</mat-icon>
    
        <mat-autocomplete #auto="matAutocomplete" #autocomplete>

            <mat-option class="custom-mat-option" *ngFor="let issue of issues" (click)="selectIssue(issue)">
                {{issue.issuetitle}}
            </mat-option>
    
        </mat-autocomplete>

    </mat-form-field>

</ng-container>
